import React from "react";

import styles from "./g-NoResults.module.scss";
import { useLocation } from "react-router-dom";

const NoResults: React.FC = () => {
  const path = useLocation().pathname.split("/")[1];
  const styleClass =
    path === "admin" || path === "jikei"
      ? `${styles["g-no-results"]} ${styles["manage"]}`
      : styles["g-no-results"];

  return <div className={styleClass}>検索結果がありません</div>;
};

export default NoResults;
